import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Helmet } from 'react-helmet';
import capitalize from 'capitalize';
import { Link, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LocationTable from '../../components/LocationTable';
import { siteMetadata } from '../../constants';

const Locations = () => {
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const pageName = capitalize(t('components.menuItems.locations'));

  return (
    <>
      <Helmet>
        <title>{`${pageName} | ${siteMetadata.TITLE}`}</title>
      </Helmet>
      <Button
        disableElevation
        variant="contained"
        color="secondary"
        style={{ marginBottom: 16, marginRight: 16 }}
        component={Link}
        to={`${url}/new`}
      >
        {t('pages.mediaDevices.addNew')}
      </Button>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <LocationTable />
        </Grid>
      </Grid>
    </>
  );
};

export default Locations;
